import React from 'react';
const testimonials = [{
  quote: 'Una crónica que no podés soltar. Cada capítulo te deja con más preguntas.',
  name: 'Martín Rodríguez',
  city: 'Buenos Aires',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=facearea&facepad=2&w=160&h=160&q=80'
}, {
  quote: 'Pensé que sabía todo sobre el caso. Este libro me demostró que no.',
  name: 'Carlos Lombardi',
  city: 'Montevideo',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=facearea&facepad=2&w=160&h=160&q=80'
}, {
  quote: 'El nivel de detalle y documentación es impresionante. Lectura obligatoria.',
  name: 'Patricia González',
  city: 'Asunción',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=facearea&facepad=2&w=160&h=160&q=80'
}];
function Stars() {
  return <div className="flex gap-1 justify-center mb-3" data-id="element-124">
      {[...Array(5)].map((_, i) => <span key={i} className="text-[#C5A014] text-lg" data-id="element-125">
          ★
        </span>)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full py-10 md:py-12 px-4 bg-black" data-id="element-126">
      <div className="max-w-5xl mx-auto" data-id="element-127">
        <h2 className="font-['Playfair_Display'] font-bold text-3xl md:text-4xl text-zinc-200 mb-8 text-center" data-id="element-128">
          Lo que dicen los primeros lectores
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-129">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-zinc-900/60 border border-zinc-800/60 p-5 flex flex-col items-center text-center" data-id="element-130">
              {/* Avatar */}
              <div className="mb-3" data-id="element-131">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border border-[#C5A014]/40 ring-1 ring-zinc-800" data-id="element-132" />
              </div>

              <Stars data-id="element-133" />

              <p className="font-['Crimson_Text'] text-base md:text-lg text-zinc-300 leading-relaxed italic mb-4" data-id="element-134">
                "{testimonial.quote}"
              </p>

              <p className="font-['Crimson_Text'] text-sm text-zinc-300 font-semibold" data-id="element-135">
                {testimonial.name}
              </p>
              <p className="font-['Crimson_Text'] text-xs text-zinc-500" data-id="element-136">
                {testimonial.city}
              </p>
              <p className="font-['Crimson_Text'] text-xs text-zinc-500 mt-2 flex items-center gap-1" data-id="element-137">
                Compra verificada{' '}
                <span className="text-[#C5A014] text-xs" data-id="element-138">✓</span>
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}